export default __webpack_public_path__ + "static/media/default.ca63d30b61e60f92777034924577e2d2.png";